export const registerConstants = {
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',

    VERIFY_REQUEST: 'VERIFY_REQUEST',
    VERIFY_SUCCESS: 'VERIFY_SUCCESS',
    VERIFY_FAILURE: 'VERIFY_FAILURE'
};
